module.exports = __webpack_public_path__ + "img/concurrent-case-active.fcf36325.svg";